/* =========================================================================
   Foxhills custom engraving configurator + LIVE preview (Phase 1).
   Replaces the HulkApps engraving UI on engrave-template products with a
   clear, validated flow and a live visualisation of the text on the item.
   Phase 2 will wire the £10 charge + the generated preview image.
   Config: window.FoxEngrave (snippets/fox-engrave.liquid).
   ========================================================================= */
(function () {
  'use strict';
  var CFG = window.FoxEngrave;
  if (!CFG || !CFG.enabled || !CFG.product) return;

  var P = CFG.product;

  /* Per-product overrides from metafield custom.engrave_config, merged over the
     defaults in the snippet. Lockets engrave Inside Left / Inside Right with no
     front-and-back flip and laser only; the birthstone discs keep front/back and
     both engraving types. Anything not overridden keeps the default. */
  (function applyConfig() {
    var c = CFG.config;
    if (typeof c === 'string') { try { c = JSON.parse(c); } catch (e) { c = null; } }
    if (!c) return;
    if (c.surfaces && c.surfaces.length) CFG.surfaces = c.surfaces;
    if (c.preview === false) CFG.preview = false;
    if (c.types && c.types.length) {
      CFG.types = CFG.types.filter(function (t) { return c.types.indexOf(t.name) !== -1; });
    }
    if (c.area) CFG.area = c.area;
    if (c.faces === null) CFG.faces = null;
    // Per-font size factors, e.g. {"Odstemplik":0.9}. Lockets use this to run the
    // wider faces a touch smaller than Roustel; unlisted fonts stay at 1.
    if (c.font_scale && typeof c.font_scale === 'object') CFG.fontScale = c.font_scale;
  })();

  var SURFACES = (CFG.surfaces && CFG.surfaces.length ? CFG.surfaces : [
    { key: 'front', label: 'Front', required: true, max: 30 },
    { key: 'back', label: 'Back', required: false, max: 30 }
  ]).map(function (sf, i) {
    return { key: sf.key, label: sf.label || sf.key,
             required: sf.required !== undefined ? !!sf.required : i === 0,
             max: sf.max || 30,
             // Per-surface artwork + text box. A locket engraves four faces across
             // two photos: closed for front/back, open for the two inside halves.
             image: sf.image_url || (sf.image_asset ? (CFG.assetBase || '') + sf.image_asset : null),
             area: sf.area || null,
             // Faces shown in the same view. An open locket shows BOTH inside
             // halves at once, so they share a group and both texts render.
             // Front and back share a photo but are opposite sides, so they do
             // not. Defaults to the key, i.e. one face per view, which is what
             // the birthstone discs do.
             group: sf.group || sf.key };
  });

  function surfaceOf(key) {
    for (var i = 0; i < SURFACES.length; i++) if (SURFACES[i].key === key) return SURFACES[i];
    return SURFACES[0];
  }
  function imageFor(sf) {
    if (sf && sf.image) return sf.image;
    if (CFG.faces) return CFG.faces[sf.key] || CFG.faces.front;
    return P.image;
  }
  function areaFor(sf) { return (sf && sf.area) || CFG.area; }
  function groupOf(key) {
    var g = surfaceOf(key).group;
    return SURFACES.filter(function (sf) { return sf.group === g; });
  }

  var state = { engrave: false, type: null, font: null, fontLabel: null,
                text: {}, side: SURFACES[0].key, confirmed: false };
  SURFACES.forEach(function (sf) { state.text[sf.key] = ''; });
  var els = {};

  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }

  /* ---------- build UI ---------- */

  function buildUI() {
    var wrap = el('div', 'fox-eng');
    wrap.innerHTML =
      '<div class="fox-eng__bar">' +
        '<span class="fox-eng__label">Personalise with engraving <em>+£10</em></span>' +
        '<div class="fox-eng__yn">' +
          '<button type="button" class="fox-eng__yn-btn is-on" data-eng="no">No</button>' +
          '<button type="button" class="fox-eng__yn-btn" data-eng="yes">Yes</button>' +
        '</div>' +
      '</div>' +
      '<div class="fox-eng__panel" hidden>' +
        (CFG.preview === false ? '' :
          '<div class="fox-eng__preview">' +
            '<img class="fox-eng__img" alt="Engraving preview">' +
            '<div class="fox-eng__text"></div>' +
          '</div>') +
        (CFG.preview !== false && SURFACES.length > 1 ?
          '<div class="fox-eng__side">' +
            SURFACES.map(function (sf, i) {
              return '<button type="button" class="fox-eng__side-btn' + (i === 0 ? ' is-on' : '') +
                '" data-side="' + sf.key + '">' + sf.label + '</button>';
            }).join('') +
          '</div>' : '') +
        '<div class="fox-eng__group"><div class="fox-eng__h">Engraving type</div><div class="fox-eng__types"></div></div>' +
        '<div class="fox-eng__group fox-eng__fonts-group" hidden><div class="fox-eng__h">Font</div><div class="fox-eng__fonts"></div></div>' +
        SURFACES.map(function (sf) {
          return '<div class="fox-eng__group"><div class="fox-eng__h">' + sf.label + ' text' +
            (sf.required ? '' : ' <span class="fox-eng__opt">optional</span>') + '</div>' +
            '<input type="text" class="fox-eng__input" data-surface="' + sf.key + '" maxlength="' + sf.max +
            '" placeholder="Up to ' + sf.max + ' characters"></div>';
        }).join('') +
        '<label class="fox-eng__confirm"><input type="checkbox" class="fox-eng__confirm-cb"> I confirm the engraving details are correct</label>' +
        '<p class="fox-eng__note">Please check your spelling carefully. All engraving is centred on the item and produced exactly as entered. Engraved items cannot be returned or exchanged, and orders can take up to 7 business days for delivery.</p>' +
        '<div class="fox-eng__err" hidden></div>' +
      '</div>';
    return wrap;
  }

  function renderTypes() {
    els.types.innerHTML = '';
    CFG.types.forEach(function (t) {
      var b = el('button', 'fox-eng__chip', t.name);
      b.type = 'button';
      b.setAttribute('data-type', t.name);
      if (state.type === t.name) b.classList.add('is-on');
      els.types.appendChild(b);
    });
  }

  function renderFonts() {
    els.fonts.innerHTML = '';
    var t = CFG.types.filter(function (x) { return x.name === state.type; })[0];
    if (!t) { els.fontsGroup.hidden = true; return; }
    els.fontsGroup.hidden = false;
    t.fonts.forEach(function (f) {
      var b = el('button', 'fox-eng__chip fox-eng__font-chip', f.label);
      b.type = 'button';
      b.style.fontFamily = f.css;
      b.setAttribute('data-font', f.css);
      b.setAttribute('data-font-label', f.label);
      if (state.fontLabel === f.label) b.classList.add('is-on');
      els.fonts.appendChild(b);
    });
  }

  /* ---------- live preview ---------- */

  /* Gecko engrave the text large, filling the face, and shrink it when the entry
     is long. Match that: start from the configured size and scale down only if the
     longest unbreakable run would not fit the box, so a short name is big and
     "12.05.1994" or a 15-character entry still lands on one line instead of
     splitting mid-word. */
  var _meas = null;
  function domMeasure(fontCss) {
    if (!_meas) {
      _meas = document.createElement('span');
      _meas.style.cssText = 'position:absolute;left:-9999px;top:0;visibility:hidden;white-space:pre;';
      document.body.appendChild(_meas);
    }
    _meas.style.fontFamily = fontCss;
    return function (str, px) { _meas.style.fontSize = px + 'px'; _meas.textContent = str; return _meas.offsetWidth; };
  }

  /* Lay text out inside a box: wrap at spaces, then shrink until the longest
     word fits the width AND the wrapped block fits the height. The five laser
     fonts differ a lot in width (Odstemplik is monospace, Allura is narrow), so
     a size that suits one wraps another onto three lines and out of the oval.
     Fitting both axes gives each font its own natural size, which is what the
     engraver does. Returns { px, lines }. */
  var LINE_H = 1.45;
  function fontScale() {
    var f = CFG.fontScale && state.fontLabel ? Number(CFG.fontScale[state.fontLabel]) : 1;
    return f > 0 && f <= 2 ? f : 1;
  }
  function layoutText(measure, text, basePx, boxPx, maxHPx, minPx) {
    var words = String(text || '').trim().split(/\s+/).filter(Boolean);
    if (!words.length) return { px: basePx, lines: [] };
    var px = basePx, lines = [], guard = 0;
    while (guard++ < 12) {
      var widest = 0, i;
      for (i = 0; i < words.length; i++) widest = Math.max(widest, measure(words[i], px));
      if (widest > boxPx) { px = Math.max(minPx, px * (boxPx / widest)); if (px === minPx) { /* fall through to wrap */ } else continue; }
      lines = []; var cur = '';
      for (i = 0; i < words.length; i++) {
        var cand = cur ? cur + ' ' + words[i] : words[i];
        if (!cur || measure(cand, px) <= boxPx) cur = cand; else { lines.push(cur); cur = words[i]; }
      }
      if (cur) lines.push(cur);
      var hgt = lines.length * px * LINE_H;
      if (!maxHPx || hgt <= maxHPx || px <= minPx) break;
      px = Math.max(minPx, px * Math.sqrt(maxHPx / hgt) * 0.98);
    }
    return { px: px, lines: lines };
  }

  function updatePreview() {
    if (CFG.preview === false) return;
    var t = els.text, box = els.preview;
    if (!t || !box) return;
    var sf = surfaceOf(state.side);
    var face = imageFor(sf);
    if (face && els.img && els.img.getAttribute('src') !== face) els.img.src = face;
    var w = box.clientWidth || 320;
    var group = groupOf(state.side);
    // One positioned label per face in this view, so an open locket shows the
    // left and right engravings together the way the finished piece reads.
    group.forEach(function (g, i) {
      var node = i === 0 ? t : els.extraText[i - 1];
      if (!node) {
        node = document.createElement('div');
        node.className = 'fox-eng__text';
        t.parentNode.appendChild(node);
        els.extraText[i - 1] = node;
      }
      var area = areaFor(g);
      var fam = state.font || "'Jost', sans-serif";
      var txt = state.text[g.key] || '';
      var bh = box.clientHeight || w;
      var fs = fontScale();
      var boxPx = (area.width / 100) * w * fs;
      var maxH = area.height ? (area.height / 100) * bh * fs : 0;
      var lay = layoutText(domMeasure(fam), txt, Math.max(12, (area.size / 100) * w) * fs, boxPx, maxH, 9);
      node.textContent = lay.lines.join('\n');
      node.style.fontFamily = fam;
      node.style.lineHeight = LINE_H;
      node.style.left = area.cx + '%';
      node.style.top = area.cy + '%';
      node.style.maxWidth = 'none';
      node.style.whiteSpace = 'pre';
      node.style.fontSize = lay.px + 'px';
      node.hidden = false;
    });
    // hide any spare labels left over from a bigger group
    for (var j = group.length - 1; j < els.extraText.length; j++) {
      if (els.extraText[j]) els.extraText[j].hidden = true;
    }
  }

  /* ---------- wiring ---------- */

  function setEngrave(on) {
    state.engrave = on;
    els.panel.hidden = !on;
    els.wrap.querySelectorAll('[data-eng]').forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-eng') === (on ? 'yes' : 'no')); });
    if (on) updatePreview();
  }

  /* Switch the preview to a given surface and sync the face buttons. */
  function setSide(key) {
    if (!key || state.side === key) { updatePreview(); return; }
    state.side = key;
    if (els.wrap) {
      els.wrap.querySelectorAll('[data-side]').forEach(function (b) {
        b.classList.toggle('is-on', b.getAttribute('data-side') === key);
      });
    }
    updatePreview();
  }

  function bind() {
    els.wrap.addEventListener('click', function (ev) {
      var t = ev.target;
      if (t.closest('[data-eng]')) { setEngrave(t.closest('[data-eng]').getAttribute('data-eng') === 'yes'); return; }
      var typeBtn = t.closest('[data-type]');
      if (typeBtn) {
        state.type = typeBtn.getAttribute('data-type');
        state.font = null; state.fontLabel = null;
        renderTypes(); renderFonts(); clearErr();
        return;
      }
      var fontBtn = t.closest('[data-font]');
      if (fontBtn) {
        state.font = fontBtn.getAttribute('data-font');
        state.fontLabel = fontBtn.getAttribute('data-font-label');
        els.fonts.querySelectorAll('.fox-eng__chip').forEach(function (c) { c.classList.toggle('is-on', c === fontBtn); });
        updatePreview(); clearErr();
        return;
      }
      var sideBtn = t.closest('[data-side]');
      if (sideBtn) { setSide(sideBtn.getAttribute('data-side')); return; }
    });
    els.inputs.forEach(function (inp) {
      var key = inp.getAttribute('data-surface');
      // Tapping or typing in a field shows that face, so the customer never has
      // to work out which button matches which box.
      inp.addEventListener('focus', function () { setSide(key); });
      inp.addEventListener('input', function () {
        state.text[key] = inp.value.trim();
        setSide(key);
        clearErr();
      });
    });
    els.confirm.addEventListener('change', function () { state.confirmed = els.confirm.checked; clearErr(); });
    window.addEventListener('resize', updatePreview);
  }

  function clearErr() { if (els.err) { els.err.hidden = true; els.err.textContent = ''; } }
  function showErr(m) { if (els.err) { els.err.hidden = false; els.err.textContent = m; els.err.scrollIntoView({ block: 'nearest' }); } }

  /* ---------- add to cart ---------- */

  function validate() {
    if (!state.type) return 'Please choose an engraving type.';
    if (!state.fontLabel) return 'Please choose a font.';
    var anyRequired = false, anyFilled = false;
    for (var i = 0; i < SURFACES.length; i++) {
      var sf = SURFACES[i];
      if (state.text[sf.key]) anyFilled = true;
      if (sf.required) {
        anyRequired = true;
        if (!state.text[sf.key]) {
          return 'Please enter the ' + sf.label.toLowerCase() + ' engraving text.';
        }
      }
    }
    // A locket has four optional surfaces (outside front/back, inside left/right)
    // and the customer picks which to use, so nothing is individually required.
    // Still refuse an engraving order with no text anywhere.
    if (!anyRequired && !anyFilled) return 'Please enter your engraving text.';
    if (!state.confirmed) return 'Please confirm the engraving details are correct.';
    return null;
  }

  // Render a small snapshot (chosen disc image + text) for the order. Guarded:
  // resolves null on CORS taint / any error so the add never breaks.
  // items: [{ text, area }] - every face shown in this view, so the image saved
  // to the order is the same picture the customer approved.
  function snapshot(imgUrl, items) {
    return new Promise(function (resolve) {
      try {
        if (!imgUrl || !items || !items.length) { resolve(null); return; }
        var img = new Image(); img.crossOrigin = 'anonymous';
        img.onload = function () {
          try {
            var w = 320, h = Math.round(w * (img.naturalHeight / img.naturalWidth || 1));
            var c = document.createElement('canvas'); c.width = w; c.height = h;
            var ctx = c.getContext('2d');
            ctx.drawImage(img, 0, 0, w, h);
            // Full family stack, not just the first name: 'Odstemplik' is not a
            // Google Fonts family so it never loads, and the screen quietly falls
            // back to the generic monospace. Passing the whole stack lets the canvas
            // fall back the same way instead of dropping to serif.
            var fam = state.font || "'Jost', sans-serif";
            ctx.fillStyle = '#7f7d7c'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
            items.forEach(function (it) {
              var fs = fontScale();
              var a = it.area, boxPx = (a.width / 100) * w * fs;
              var maxH = a.height ? (a.height / 100) * h * fs : 0;
              var lay = layoutText(function (str, px) { ctx.font = px + 'px ' + fam; return ctx.measureText(str).width; },
                                   it.text, (a.size / 100) * w * fs, boxPx, maxH, 6);
              ctx.font = lay.px + 'px ' + fam;
              var lh = lay.px * LINE_H, y0 = (a.cy / 100) * h - (lay.lines.length - 1) * lh / 2, k;
              for (k = 0; k < lay.lines.length; k++) ctx.fillText(lay.lines[k], (a.cx / 100) * w, y0 + k * lh);
            });
            resolve(c.toDataURL('image/jpeg', 0.6));
          } catch (e) { resolve(null); }
        };
        img.onerror = function () { resolve(null); };
        img.src = imgUrl;
      } catch (e) { resolve(null); }
    });
  }

  /* Link to this product page with the engraving filled in (engrave_view=1),
     so the team can open the exact preview from the order. Replaces the
     snapshot images, which the order page showed as thousands of characters of
     image code around the text (Louise, order #11427, 19 Oct 2026). */
  function previewLink() {
    var q = new URLSearchParams();
    q.set('variant', P.variantId);
    q.set('engrave_view', '1');
    q.set('et', state.type || '');
    q.set('ef', state.fontLabel || '');
    SURFACES.forEach(function (sf) { if (state.text[sf.key]) q.set('e_' + sf.key, state.text[sf.key]); });
    return location.origin + '/products/' + P.handle + '?' + q.toString();
  }

  function addEngraved() {
    return Promise.resolve().then(function () {
      var props = {
        'Engraving?': 'Yes (£10.00)',
        'Engraving Type': state.type,
        'Font': state.fontLabel,
        'Review Your Engraving': 'I confirm the engraving details are correct'
      };
      SURFACES.forEach(function (sf, i) {
        if (state.text[sf.key]) props['Text ' + sf.label] = state.text[sf.key];
      });
      // underscore = hidden in cart, kept on the order
      if (CFG.preview !== false) props['_Engraving preview'] = previewLink();
      var key = Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2);
      props['_engrave_key'] = key;
      var items = [{ id: P.variantId, quantity: 1, properties: props }];
      // linked £10 engraving fee line (the Engraving product)
      if (CFG.engraveVariantId) {
        items.push({ id: CFG.engraveVariantId, quantity: 1, properties: { _engrave_key: key, 'Engraving for': P.title } });
      }
      return fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); });
    });
  }

  function interceptAdd() {
    document.addEventListener('click', function (ev) {
      var btn = ev.target.closest && ev.target.closest('.product-single__form button[name="add"], button.add-to-cart, .add-to-cart');
      if (!btn || btn.closest('.shopify-payment-button') || btn.closest('#FoxAddonRail')) return;
      if (!state.engrave) return;          // no engraving -> let the normal add run
      ev.preventDefault();
      ev.stopImmediatePropagation();
      var err = validate();
      if (err) { showErr(err); return; }
      btn.classList.add('btn--loading');
      addEngraved()
        .then(function () { if (window.jQuery) window.jQuery('body').trigger('added.ajaxProduct'); })
        .catch(function () { showErr('Something went wrong adding to cart. Please try again.'); })
        .then(function () { btn.classList.remove('btn--loading'); });
    }, true);
  }

  /* ---------- init ---------- */

  function init() {
    // hide the HulkApps engraving options (we own engraving now)
    document.querySelectorAll('[id^="hulkapps_custom_options_"]').forEach(function (h) { h.style.display = 'none'; });
    // inject our UI just before the add-to-cart button
    var btn = document.querySelector('.product-single__form button[name="add"], button.add-to-cart, .add-to-cart');
    if (!btn) return;
    var ui = buildUI();
    (btn.closest('.payment-buttons') || btn).parentNode.insertBefore(ui, (btn.closest('.payment-buttons') || btn));
    els.wrap = ui;
    els.panel = ui.querySelector('.fox-eng__panel');
    els.preview = ui.querySelector('.fox-eng__preview');
    els.img = ui.querySelector('.fox-eng__img');
    els.text = ui.querySelector('.fox-eng__text');
    els.extraText = [];
    els.types = ui.querySelector('.fox-eng__types');
    els.fonts = ui.querySelector('.fox-eng__fonts');
    els.fontsGroup = ui.querySelector('.fox-eng__fonts-group');
    els.inputs = Array.prototype.slice.call(ui.querySelectorAll('.fox-eng__input'));
    els.confirm = ui.querySelector('.fox-eng__confirm-cb');
    els.err = ui.querySelector('.fox-eng__err');
    // els.img only exists when the live preview is on. Seed it from the first
    // surface so a locket opens on its own artwork, not the product photo.
    if (els.img) {
      var first = imageFor(SURFACES[0]);
      if (first) els.img.src = first;
    }
    // With a single engraving type there is nothing to choose: preselect it and
    // hide the row rather than making the customer tap a one-option list.
    if (CFG.types.length === 1) {
      state.type = CFG.types[0].name;
      var tg = ui.querySelector('.fox-eng__types');
      if (tg && tg.parentNode) tg.parentNode.hidden = true;
    }
    renderTypes();
    renderFonts();
    bind();
    interceptAdd();
    openFromLink();
  }

  /* engrave_view=1: rebuild an order's engraving from its preview link. Fills
     the form only; nothing is added and the confirm box stays unticked. */
  function openFromLink() {
    var q = new URLSearchParams(location.search);
    if (q.get('engrave_view') !== '1') return;
    setEngrave(true);
    var et = q.get('et'), ef = q.get('ef');
    if (et && CFG.types.some(function (t) { return t.name === et; })) { state.type = et; renderTypes(); renderFonts(); }
    if (ef) {
      var chip = Array.prototype.filter.call(els.fonts.querySelectorAll('[data-font-label]'), function (c) { return c.getAttribute('data-font-label') === ef; })[0];
      if (chip) chip.click();
    }
    var firstKey = null;
    els.inputs.forEach(function (inp) {
      var key = inp.getAttribute('data-surface'), v = q.get('e_' + key);
      if (v == null) return;
      inp.value = v; state.text[key] = v.trim();
      if (!firstKey) firstKey = key;
    });
    var note = el('p', 'fox-eng__note fox-eng__note--order');
    note.textContent = 'Engraving preview from an order. Check the text and font against the order before engraving.';
    els.panel.insertBefore(note, els.panel.firstChild);
    setSide(firstKey || SURFACES[0].key);
    updatePreview();
    els.wrap.scrollIntoView({ block: 'center' });
  }

  function ready() {
    // hide HulkApps as soon as possible, then build once the form exists
    var tries = 0;
    (function wait() {
      tries++;
      var btn = document.querySelector('.product-single__form button[name="add"], button.add-to-cart, .add-to-cart');
      if (btn) { init(); }
      else if (tries < 100) { setTimeout(wait, 100); }
    })();
  }
  if (document.readyState !== 'loading') ready();
  else document.addEventListener('DOMContentLoaded', ready);
})();
